import styled from 'styled-components';

export const ErrorBody = styled.div`
  margin: auto;
  width: 90%;
  padding: 10px;
`;
